import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { Modal } from "react-bootstrap";
import { ArrowRightIcon, DownloadIcon } from "@fluentui/react-icons-northstar";
import { CSVLink } from "react-csv";

import GaldermaChatScriptTable from "../../components/GaldermaChatScriptTable/GaldermaChatScriptTable";

import styles from "./Galderma.module.css";
import { getGaldermaBotStats, getGaldermaExportData } from "../../utils/Api";
import { handleLoaderEvent } from "../../utils/LoaderEmitter";
import Menu from "../../components/Menu/Menu";
import KPICards from "../../components/KPICards/KPICards";

const menuItems = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Dashboard",
    link: "/dashboard",
  },
  {
    name: "Data Catalogue",
    link: "/data-catalogue",
  },
];

interface DateSelection {
  startDate: Date;
  endDate: Date;
  color?: string | undefined;
  key?: string | undefined;
  autoFocus?: boolean | undefined;
  disabled?: boolean | undefined;
  showDateDisplay?: boolean | undefined;
}
interface exportData {
  userName: string;
  role:string;
  content: string;
  timeStamp: string;
  sessionId: string;
}
interface Conversation {
    role: string;
    content: string;
    timestamp: string;
  }

const csvHeaders = [
  { label: "User Name", key: "userName" },
  { label: "Role", key: "role" },
  { label: "Message", key: "content" },
  { label: "Time Stamp", key: "timeStamp" },
  { label: "Session Id", key: "sessionId" },
];

const parseDateForFilter = (date: Date) => {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

const parseExportData = (
  data: any
) => {
  const exportData: exportData[] = [];

  const userNames = Object.keys(data);

  userNames.forEach((userName) => {
    const sessionObj:any = Object.entries(data)[0][1];
    const sessions = Object.keys(sessionObj);
    sessions.forEach((session) => {
      const conversations:any = Object.values(Object.values(sessionObj[session]));
      conversations.forEach((conversation: { role: any; content: any; timestamp: any; }) => {
        exportData.push({
          userName: userName,
          role: conversation.role,
          content: conversation.content,
          timeStamp: conversation.timestamp,
          sessionId: session,
        });
      });
    });
  });
  return exportData;
};

const GaldermaDashboard = () => {
  // const [isOpen, setIsOpen] = useState(false);

  const [transcriptData, setTranscriptData] = useState([]);
  const [kpiStats, setKpiStats] = useState([]);
  const [addModalShow, setAddModalShow] = useState(false);
  const [csvData, setCSVData] = useState<exportData[]>([]);

  // Default selection of 2 days range
  const [selectionRange, setSelectionRange] = useState<DateSelection>({
    startDate: new Date(new Date().setDate(new Date().getDate() - 2)),
    endDate: new Date(),
    key: "selection",
  });
  useEffect(() => {
    (async () => {
      handleLoaderEvent.emit("loader", true);
      const botStats = await getGaldermaBotStats(parseDateForFilter(selectionRange.startDate), parseDateForFilter(selectionRange.endDate));
      const exportCsv = await getGaldermaExportData(parseDateForFilter(selectionRange.startDate), parseDateForFilter(selectionRange.endDate));

      setTranscriptData(botStats.result?.allQues || []);
      setKpiStats(botStats.result?.stats || []);

      const parsedData:exportData[]= parseExportData(exportCsv.result);
      setCSVData(parsedData);
      handleLoaderEvent.emit("loader", false);
    })();
  }, [selectionRange]);

  const handleDateRangeFilterSelect = (ranges: any) => {
    setSelectionRange(ranges.selection);
    addModalHandleClose();
  };

  const addModalHandleClose = () => setAddModalShow(false);

  const addModalHandleShow = () => setAddModalShow(true);

  return (
    <>
      <Menu menuItems={menuItems}></Menu>
      <div className="mt-5">
        {kpiStats.length > 0 && (
          <div>
            <div className={styles.tableHeaderPanel}>
              <div className={styles.tableHeader}>KPI</div>

              <div className={`${styles.filterRangeContainer}`}>
                {/* <div className={styles.filterDateHeader}>
                                    Select Time Range
                                </div> */}

                <div className={styles.filterDatesContainer} onClick={addModalHandleShow}>
                  <span className={styles.filterDateDisplay}>
                    {selectionRange.startDate.getDate()}-{selectionRange.startDate.getMonth() + 1}-{selectionRange.startDate.getFullYear()}
                  </span>
                  <ArrowRightIcon size="large" outline className={styles.arrowIcon} />
                  <span className={styles.filterDateDisplay}>
                    {selectionRange.endDate.getDate()}-{selectionRange.endDate.getMonth() + 1}-{selectionRange.endDate.getFullYear()}
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.divider} />
            <KPICards kpis={kpiStats} />
          </div>
        )}

        {transcriptData.length > 0 && (
          <div>
            <div className={`${styles.tableHeaderPanel}`}>
              <div className={`${styles.tableHeader}`}>User Queries</div>

              <div className={`${styles.filterRangeContainer} `}>
                    <div className={styles.filterDatesContainer} onClick={addModalHandleShow}>
                  <span className={styles.filterDateDisplay}>
                    {selectionRange.startDate.getDate()}-{selectionRange.startDate.getMonth() + 1}-{selectionRange.startDate.getFullYear()}
                  </span>
                  <ArrowRightIcon size="large" outline className={styles.arrowIcon} />
                  <span className={styles.filterDateDisplay}>
                    {selectionRange.endDate.getDate()}-{selectionRange.endDate.getMonth() + 1}-{selectionRange.endDate.getFullYear()}
                  </span>
                </div>
              </div>

             {/*

              <div className="col-3">
                <CSVLink filename={"Chat Transcript.csv"} data={csvData} headers={csvHeaders}>
                  <button className={`mx-2 ${styles.exportButton}`}>
                    Download Transcript <DownloadIcon size="large" outline className={styles.downloadIcon} />
                  </button>
                </CSVLink>
              </div>
        */}


            </div>

            <div className={styles.divider} />
            <GaldermaChatScriptTable chatTranscriptList={transcriptData} />
          </div>
        )}
      </div>

      <Modal className="modal-lg" show={addModalShow} onHide={addModalHandleClose}>
        <Modal.Body>
          <Modal.Title>Select Time Range</Modal.Title>
          <DateRangePicker ranges={[selectionRange]} onChange={handleDateRangeFilterSelect} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GaldermaDashboard;
